import axios from "axios";
import {
  getApiPaginationProd,
  getApiProd,
  postApiProd,
} from "services/mainService";

export const loginUserModel = async (token, phone_number, password) => {
  try {
    const response = await postApiProd(
      "auth/v2/login/user",
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        phone_number,
        password,
      }
    );

    if (!response.success) {
      return { success: false, message: response.message };
    }

    const data = response.data;

    return {
      success: true,
      data: {
        id: data.id,
        idDivision: data.kodediv,
        username: data.username,
        email: data.email,
        phoneNumber: data.phoneNumber,
        modules: data.modules,
        divisionName: data.namadivisi,
        companyName: data.namausaha,
        token: data.token,
      },
      message: response.message,
    };
  } catch (err) {
    return {
      success: false,
      message: err.message || "Login failed",
    };
  }
};
export const loginCompanyModel = async (email, password) => {
  try {
    const response = await postApiProd("auth/login/company", null, null, {
      email,
      password,
    });

    if (!response.success) {
      return { success: false, message: response.message };
    }

    const data = response.data;

    return {
      success: true,
      data: {
        id: data.id,
        name: data.name,
        email: data.email,
        token: data.token,
      },
      message: response.message,
    };
  } catch (err) {
    return {
      success: false,
      message: err.message || "Login failed",
    };
  }
};
export const checkEmailCompanyModel = async (email) => {
  try {
    const response = await postApiProd("auth/checkemail", null, null, {
      email,
    });

    if (!response.success) {
      return { success: false, message: response.message };
    } else
      return {
        success: true,
        message: response.message,
      };
  } catch (err) {
    return {
      success: false,
      message: err.message || "Login failed",
    };
  }
};
export const getListUserModel = async (
  token,
  page = 1,
  limit = 10000,
  search = ""
) => {
  try {
    const response = await getApiPaginationProd(
      "auth/list",
      {
        Authorization: `Bearer ${token}`,
      },
      {
        page,
        limit,
        search,
      }
    );
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
        totalPage: response.totalPage,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
};

export const createUserModel = async (
  token,
  email,
  password,
  modules,
  username,
  phoneNumber
) => {
  try {
    const response = await postApiProd(
      `auth/register`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        email,
        password,
        modules,
        username,
        phoneNumber,
      }
    );

    if (!response.success) return { success: false, message: response.message };
    else
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const updateUserModel = async (
  token,
  id,
  email,
  password,
  modules,
  username,
  phoneNumber
) => {
  try {
    const response = await postApiProd(
      `auth/update`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        id,
        email,
        password,
        modules,
        username,
        phoneNumber,
      }
    );

    if (!response.success) return { success: false, message: response.message };
    else
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const deleteUserModel = async (token, id) => {
  try {
    const response = await postApiProd(
      `auth/delete`,
      {
        Authorization: `Bearer ${token}`,
      },
      null,
      {
        id,
      }
    );

    if (!response.success) return { success: false, message: response.message };
    else
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
  } catch (error) {
    return { success: false, message: error.message };
  }
};

export const getUserModel = async (token, id) => {
  try {
    const response = await getApiProd(
      "auth/item",
      {
        Authorization: `Bearer ${token}`,
      },
      {
        id,
      }
    );
    if (response.success)
      return {
        success: true,
        data: response.data,
        message: response.message,
      };
    else
      return {
        success: false,
        message: response.message,
      };
  } catch (error) {
    return {
      success: false,
      message: error.message,
    };
  }
};
